import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showSerialHelpOverlay } from '../../../actions/serialhelpoverlay';
import {
  InputOrderFormField
} from '../../atoms/InputOrderFormElements';
import Headline from '../../atoms/Headline';
import SimpleButton from '../../atoms/SimpleButton';
import cssVars from '../../../assets/export.css';
import { setSerial, resetSerial } from '../../../actions/status';

var AppConfig = require('../../../config.json');

class OptionsRequestSerial extends React.Component {
	constructor(props) {
      super(props);
      this.showInfo = this.showInfo.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setSn = this.setSn.bind(this);
    this.resetSn = this.resetSn.bind(this);
      this.state = {
        serial: '',
        isset: false
      };
    }

    componentDidMount() {
      if(this.props.requestSerial.sn!=="") {
        this.setState({serial: this.props.requestSerial.sn, isset: true}, this.setSn);
      }
    }
    handleSubmit(e) {
      e && e.preventDefault();
      return;
    }
    handleChange(targ, hasError) {
      var tmp = {};
      if(hasError || targ.value==='') {
        this.setState({serial: '', isset: false}, this.resetSn);
      } else {
        this.setState({serial: targ.value, isset: true}, this.setSn);
      }
    }
    setSn() {
      this.props.dispatch(setSerial(this.state.serial));
      this.props.onChange(this.state.serial);
    }
    resetSn() {
      this.props.dispatch(resetSerial());
      this.props.onChange('');
    }
    componentWillUpdate(nextProps, nextState) {
      

    }

    showInfo() {
      this.props.dispatch(showSerialHelpOverlay({}));
    }

    render () {
        return (
          <div className="optionsrequestserial">
            <div className="header">
              <Headline typeOf="h3">Seriennummer</Headline>
            </div>
            <div className="inner">
            	  <div className="input">
                  <InputOrderFormField
                      label="Geräteseriennummer"
                      required={true}
                      name="serial"
                      ref="serial"
                      value={this.props.requestSerial.sn}
                      onChange={this.handleChange}
                    />
                </div>
                <div className="help">
                  <p>Hier erfährst du, wie du die Seriennummer findest</p>
                  <SimpleButton onClick={this.showInfo}>Seriennummer iPad finden</SimpleButton>
                  
                </div>
            </div>
          </div>
        );
    }

}

OptionsRequestSerial.propTypes = {
	// /** configuration object */
	// config: PropTypes.object.isRequired,
	// /** checkSelected */
	// checkSelect: PropTypes.func,
	// /** Gets called when the user changes a config */
	// onChange: PropTypes.func,
  // isSingleChoice:PropTypes.bool
}


OptionsRequestSerial.defaultProps = {
  // isSingleChoice: false
  
}

const mapStateToProps = (state) => {
  return {
    requestSerial: state.status.requestSerial
  }
}
const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsRequestSerial)






// WEBPACK FOOTER //
// ./src/components/molecules/OptionsRequestSerial/OptionsRequestSerial.js